import { render, staticRenderFns } from "./NavMenuSmall.vue?vue&type=template&id=4a5ae038"
import script from "./NavMenuSmall.vue?vue&type=script&lang=js"
export * from "./NavMenuSmall.vue?vue&type=script&lang=js"
import style0 from "./NavMenuSmall.vue?vue&type=style&index=0&id=4a5ae038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports